module.exports = [{
      plugin: require('/codebuild/output/src944867914/src/gatsby-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
